import React, { useEffect, useState, useRef } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import RedeemService from '../../services/redeem.service';
import { loadRedeemState } from '../../hooks/redeem/redeemPersistence';

export default function VerifyEmailView() {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying | ok | error
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      const persisted = loadRedeemState() || {};
      const code = searchParams.get('code') || persisted.couponCode || '';
      try {
        // El enlace del correo se abre desde cualquier dispositivo: la
        // verificación depende SOLO del token, nunca del estado del navegador.
        // El backend emite un JWT (magic-link) para dejar al usuario logueado
        // y que pueda continuar el redeem (elegir canal, conectar integraciones).
        const data = await RedeemService.verifyEmailToken(token);
        setStatus('ok');

        const jwt = data?.jwt_token;
        if (jwt) {
          localStorage.setItem('access_token', jwt);
          localStorage.setItem('token_expires_at', new Date(Date.now() + 55 * 60 * 1000).toISOString());
        }

        // Avisar a la pestaña original del redeem (si se abrió el enlace en otra
        // pestaña): el evento `storage` de localStorage cruza pestañas del mismo
        // navegador y hace que aquella avance al paso de canal.
        try {
          localStorage.setItem('redeem_email_verified', String(Date.now()));
        } catch (_) { /* storage bloqueado: no-op */ }

        // Volver al redeem con la señal de verificación en la URL (viaja entre
        // pestañas/dispositivos, a diferencia del sessionStorage por-pestaña).
        // RedeemView la usa para avanzar al paso de elegir canal.
        const params = new URLSearchParams({ verified: '1' });
        if (code) params.set('code', code);
        navigate(`/redeem?${params.toString()}`);
      } catch (_) {
        setStatus('error');
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const wrap = {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'radial-gradient(ellipse at 50% 0%, #1e0a3c 0%, #09090f 60%)',
    color: '#e2e2f0', fontFamily: 'Arial', textAlign: 'center', padding: 24,
  };

  if (status === 'verifying') return <div style={wrap}>Verificando tu correo…</div>;
  if (status === 'error') return (
    <div style={wrap}>
      <div>
        <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>El enlace no es válido o expiró</div>
        <div style={{ color: '#888', fontSize: 14 }}>Volvé al redeem y pedí un nuevo enlace de verificación.</div>
      </div>
    </div>
  );
  return <div style={wrap}>¡Correo verificado! Redirigiendo…</div>;
}
